import "@pws/coquille-ui/styles.css";
import { ModuleCard as CoquilleModuleCard } from "@pws/coquille-ui";
import { injectCoquilleTokens } from "./injectCoquilleTokens.js";

injectCoquilleTokens();

export { CoquilleModuleCard as ModuleCard };
